import pdfMake from "pdfmake";
import html2canvas from 'html2canvas';
import TaskModalView from "./taskModal.html";
import moment from "moment";

angular.module("tasks")

    .filter('formatTaskUsers', function () {
        return function (taskUser) {
            var ret = "";
            ret += "<b>" + taskUser.FK_tasks_users_users.name + "</b>";
            if (taskUser.FK_tasks_users_users.mail != null) ret += "<br><a href='mailto:" + taskUser.FK_tasks_users_users.mail + "' class='btn btn-default btn-xs'><i class='fa fa-envelope' /> Enviar correo</a>";
            return ret;
        };
    })

    .controller("TasksListCtrl", ['entity_type', 'entity_type_id', 'LoginService', '$rootScope', '$scope', 'Restangular', 'gridService', 'modalService', '$uibModal', '$filter', '$translate', '$stateParams', '$state', 'uiGridConstants', '$timeout', '$q', '$http', 'uiGridTreeViewConstants', 'treeService', '$sce', 'datasetsService', 'logService',
        function (entity_type, entity_type_id, LoginService, $rootScope, $scope, Restangular, gridService, modalService, $uibModal, $filter, $translate, $stateParams, $state, uiGridConstants, $timeout, $q, $http, uiGridTreeViewConstants, treeService, $sce, datasetsService, logService) {

        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("TASKS_WRITE");
        $scope.gantt_data = [];
        $scope.diagramView = false;
        $scope.search = {};
        $scope.showDiagram = function (val) {
            $scope.diagramView = val;
        }

        $scope.headersFormats = {
            'year': 'YYYY',
            month: 'MM / YYYY',
            day: 'D',
        };

        if ($state.current.name == 'tasks.list') {
            $rootScope.title = $filter('translate')('events.tasks.title');
            $rootScope.breadcrumb = [
                { title: $filter('translate')('events.tasks.tasks') }
            ];
        }

        $scope.task = {};
        $scope.getToday = new Date();
        $scope.currentDate = "line";
        $scope.viewScale = "day";
        $scope.classSize = "col-lg-12 col-md-12";

        function isDefinedAndNotNull(val) {
            return angular.isDefined(val) && val !== null;
        }
            
        $scope.statusOptions = [];
        Restangular.all('TasksStatus').getList({ entity_type: entity_type }).then(function (results) {
            angular.forEach(results, function (statusOption) {
                $scope.statusOptions.push({
                    value: statusOption.id,
                    label: statusOption.name
                });
            });

        });
        var initialized = false;

        $scope.show_gantt = false;
        $scope.show_groups = false;
        let loadConfigurationOptions = function () {
            let group_name = (entity_type == "correspondence" ? "Tareas correspondencia" : "");
            Restangular.all('Configurations').getList({ code: "", group_name: group_name  }).then(function (response) {
                let configuration = response;

                let show_gantt_string = configuration.filter(function (config) { return config.code == "SHOW_GANTT"; }).map(function (config) { return config.value; })[0];
                logService.debug("show_gantt: ", $scope.show_gantt);
                $scope.show_gantt = (show_gantt_string == 'true' ? true : false);


                let show_groups_string = configuration.filter(function (config) { return config.code == "SHOW_GROUPS";}).map(function (config) { return config.value; })[0];
                logService.debug("show_groups: ", $scope.show_groups);
                $scope.show_groups = (show_groups_string == 'true' ? true : false);

            });
        }
        if (entity_type == "correspondence") loadConfigurationOptions(); //Ahora sólo se utiliza la parte de tareas desde correspondencia, si se utilizase desde otro sitio, habría que saber si se quiere configurar o no.

        $scope.pdfMaker = function () {
            //$('html, body').scrollTop(0);
                    
            var container = angular.element('#gantt-container');

            $("#gantt-container #gantt-to-export .gantt-row-label").css("font-size", "25px").css("height", "50").css("color", "#000000");
            $("#gantt-container #gantt-to-export .gantt-row-height").css("font-size", "24px").css("height", "50").css("color", "#000000");
            $("#gantt-container #gantt-to-export .gantt-task .gantt-task-content > span > font").hide()
            $("#gantt-container #gantt-to-export .gantt-header-row").css("font-size", "25px").css("height", "50").css("color", "#000000");
            $("#gantt-container #gantt-to-export .gantt-tree-handle-button").hide();//ocultamos el desplegable.

            var widthShow = angular.element("#gantt-to-export .gantt-side").width() + $("#gantt-container-shown .gantt-scrollable")[0].scrollWidth;
            widthShow = widthShow + 1000;


            $("#gantt-container #gantt-to-export").css("width", widthShow ); //Le pongo el tamaño de lo que se visualiza!!
            container.show();


            // var width = angular.element('#gantt-to-export .gantt-side').width() + angular.element('#gantt-to-export .gantt-scrollable-header').width();
            //var width2 = angular.element('#gantt-to-export').width();
                                        
                var height = (angular.element('#gantt-container #gantt-to-export').height() + 500)*2;

                logService.debug("height: " + angular.element('#gantt-container #gantt-to-export').height());
                var results = document.getElementById('gantt-to-export');

                 html2canvas(document.querySelector("#gantt-to-export")).then(canvas => {
                    var data = canvas.toDataURL("image/png", 1.0);
                    var docDefinition = {
                        pageSize: {
                            width: widthShow + 500,
                            height: angular.element('#gantt-to-export').height() + 1000//height
                        },
                        content: [{
                            image: data,
                            width: widthShow + 200
                        }]
                    };

                    // @ts-ignore
                    pdfMake.createPdf(docDefinition).download("gantt.pdf");
                    container.hide();

                });
            }

        $scope.gridOptionsTasks = {
            pdfTitle: function () { return $scope.event.name + " - " + $filter('translate')('events.tasks.pdf_title'); },
            exporterMenuCsv: true,
            enableGridMenu: true,
            showTreeExpandNoChildren: false,
            enableSorting: true,
            paginationPageSizes: [15, 30, 60],
            paginationPageSize: 15,
            rowTemplate: '<div ng-dblclick="grid.appScope.addTask(row.entity.id, true)"  ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            exporterFieldCallback: function (grid, row, col, value) {
                var valueReturned = "";
                if (col.name == 'users') {
                    if (angular.isDefined(row.entity.FK_tasks_users_tasks) && row.entity.FK_tasks_users_tasks.length > 0) {
                        row.entity.FK_tasks_users_tasks.forEach(function (item) {
                            if (valueReturned != "" && item.FK_tasks_users_users.name != "") valueReturned += ", ";
                            valueReturned += item.FK_tasks_users_users.name;
                        });
                    }
                    return valueReturned;
                } else if (col.name == "title") {
                    if (!row.entity.is_group) {
                        return "-- " + value;
                    } else {
                        return value;
                    }
                } else if (col.name == "task_status_name" && !row.entity.is_group) {

                    if (angular.isDefined(row.entity.FK_tasks_tasks_status)) {
                        if (row.entity.FK_tasks_tasks_status.code == "COMPLETED") {
                            return $filter('translate')('events.tasks.completed');
                        } else if (row.entity.FK_tasks_tasks_status.code == "CANCELED") {
                            return $filter('translate')('events.tasks.canceled');
                        } else if (row.entity.FK_tasks_tasks_status.code == "IN_PROGRESS") {
                            return $filter('translate')('events.tasks.work_progress') + " " + row.entity.work_progress + "%";

                        } else if (row.entity.FK_tasks_tasks_status.code == "PENDING") {
                            return $filter('translate')('events.tasks.pending');
                        } else {
                            return "";
                        }
                    }
                    return value;
                } else {
                    return value
                }
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    name: 'title', displayName: $filter('translate')('events.tasks.title_field'), enableFiltering: true, enableHiding: false, enableColumnMenu: false,
                    minWidth:75,
                    cellTemplate: '<div class="ui-grid-cell-contents"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.title" popover-append-to-body="true"><span ng-if="!row.entity.is_group">&nbsp;&nbsp;&nbsp;&nbsp;</span>{{row.entity.title}}</a></div>',
                },
                {
                    name: 'users', enableSorting: false, displayName: $filter('translate')('events.tasks.persons'), enableFiltering: true, enableColumnMenu: false,
                    //cellTemplate: '<div class="ui-grid-cell-contents"><img ng-repeat="taskUser in row.entity.FK_tasks_users_tasks" popover-placement="top" popover-popup-close-delay="2" popover-trigger="click outsideClick" uib-popover-html="taskUser | formatTaskUsers" popover-append-to-body="true" ng-src="{{taskUser.FK_tasks_users_users.photo}}" class="img-circle margin-right-2" height="100%"></div>',
                    cellTemplate: '<div class="ui-grid-cell-contents"><img ng-repeat="taskUser in row.entity.FK_tasks_users_tasks" popover-placement="top" popover-popup-close-delay="2" popover-trigger="click outsideClick" uib-popover-html="taskUser | formatTaskUsers" popover-append-to-body="true" ng-src="'+ (window as any).CONFIG.api_url +'/Users/GetImageUser?id={{taskUser.user_id}}" class="img-circle margin-right-2" height="100%"></div>',
                    maxWidth: 120, enableHiding: true, visible: true
                },
                { name: 'color', displayName: $filter('translate')('general.color'), enableFiltering: false, cellTemplate: gridService.colorTemplate("color"), maxWidth: 30 },
                {
                    name: 'date_from', displayName: $filter('translate')('events.date_from'), enableFiltering: false,
                    cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.all_day">{{row.entity.date_from | toLocalDate | date:"dd/MM/yy"}}</div>' +
                        '<div class="ui-grid-cell-contents" ng-if="!row.entity.all_day">{{row.entity.date_from | toLocalDate | date:"dd/MM/yy HH:mm"}}</div>',
                    maxWidth: 125, minWidth: 105, enableHiding:true, visible: true,
                    customFormatFn: function (value) {
                        if (value != null) {
                            var fecha = new Date(value);
                            if (fecha.getHours() != 0) {
                                return $filter('date')(fecha, 'dd/MM/yy HH:mm');
                            } else {
                                return $filter('date')(fecha, 'dd/MM/yy');
                            }

                        }
                        return "";
                    },
                },
                {
                    name: 'date_to', displayName: $filter('translate')('events.date_to'), enableFiltering: false,
                    cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.all_day">{{ row.entity.date_to | toLocalDate | date:"dd/MM/yy"}}</div>' +
                        '<div class="ui-grid-cell-contents" ng-if="!row.entity.all_day">{{ row.entity.date_to | toLocalDate | date:"dd/MM/yy HH:mm"}}</div>',
                    maxWidth: 125, minWidth: 105, enableHiding: true, visible: true,
                    customFormatFn: function (value) {
                        if (value != null) {
                            var fecha = new Date(value);
                            if (fecha.getHours() != 0) {
                                return $filter('date')(fecha, 'dd/MM/yy HH:mm');
                            } else {
                                return $filter('date')(fecha, 'dd/MM/yy');
                            }
                        }
                        return "";
                    },
                    enableColumnMenu: false
                },
                {
                    name: 'task_status_name', enableFiltering: true, filter: { selectOptions: $scope.statusOptions, type: uiGridConstants.filter.SELECT },
                    displayName: $filter('translate')('events.tasks.task_status'), cellTemplate: '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_tasks_tasks_status.code == \'PENDING\' && !row.entity.is_group"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.FK_tasks_tasks_status.FK_tasks_status_tl_tasks_status[0].name" popover-append-to-body="true"><label style="display: block; padding-top: 5px; padding-bottom: 5px; overflow:hidden;" class="label label-warning">&nbsp;</label></a></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_tasks_tasks_status.code == \'COMPLETED\' && !row.entity.is_group"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.FK_tasks_tasks_status.FK_tasks_status_tl_tasks_status[0].name" popover-append-to-body="true"><label style="display: block; padding-top: 5px; padding-bottom: 5px; overflow:hidden;" class="label label-primary">&nbsp;</label></a></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_tasks_tasks_status.code == \'CANCELED\' && !row.entity.is_group"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.FK_tasks_tasks_status.FK_tasks_status_tl_tasks_status[0].name" popover-append-to-body="true"><label style="display: block; padding-top: 5px; padding-bottom: 5px; overflow:hidden;" class="label label-danger">&nbsp;</label></a></div>' +
                        '<div class="ui-grid-cell-contents" ng-if="row.entity.FK_tasks_tasks_status.code == \'IN_PROGRESS\' && !row.entity.is_group">' +
                            '<div class="progress progress-striped" style="background-color: #e6e6e6;"><a class="aColorBlack" popover-placement="top" popover-trigger="mouseenter click outsideClick" uib-popover-html="row.entity.work_progress" popover-append-to-body="true"><div ng-style="{\'width\': row.entity.work_progress + \'%\'}" aria-valuemax="100" aria-valuemin="0" aria-valuenow="{{row.entity.work_progress}}" role="progressbar" class="progress-bar progress-bar-warning"></div></a></div>' +
                        '</div>',
                    width: 75, enableHiding: true, visible: true,
                    enableColumnMenu: false
                },
                {
                    name: ' ', width: 40, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionIconTemplate([
                        { title: "", action: ' ng-click="grid.appScope.addTask(row.entity.id, true)" ng-if="grid.appScope.allowWrite && row.entity.id != null" style="padding: 1px 0px"', cssIconClass: "fa fa-edit" },
                        { title: "", action: 'ng-click="grid.appScope.deleteDialog(row.entity.id,row.entity.title);" ng-if="grid.appScope.allowWrite && row.entity.id != null" style="padding: 1px 0px"', cssIconClass: "fa fa-remove" }
                    ], { cssClass: "pull-right" })
                },
            ],
            getData: function (options) {
                var deferred = $q.defer();
                options.dateFrom1 = $scope.search.dateFrom1;
                options.dateFrom2 = $scope.search.dateFrom2;
                options.dateTo1 = $scope.search.dateTo1;
                options.dateTo2 = $scope.search.dateTo2;
                options.entity_type_id = entity_type_id;
                options.entity_type = entity_type;

                return Restangular.all('Tasks').getList(options);

            }
        };


        var addToGantt = function (event_task, event_task_2) {
            if (event_task_2.date_to == null || typeof event_task_2.date_to == "undefined") event_task_2.date_to = moment(event_task_2.date_from).add(1, 'days');
            var contentTooltip = "";
            contentTooltip += "<b>" + event_task_2.title + "</b></br>"
            contentTooltip += "Desde: " + moment(event_task_2.date_from).format("DD/MM/YYYY HH:mm") + "</br>";
            contentTooltip += "Hasta: " + moment(event_task_2.date_to).format("DD/MM/YYYY HH:mm") + "</br>"
            contentTooltip += "Personas: ";
            angular.forEach(event_task_2.FK_tasks_users_tasks, function (user) {
                contentTooltip += user.FK_tasks_users_users.name + ", ";
            });
            contentTooltip = contentTooltip.slice(0, -2);

            var color = "#dddddd";
            logService.debug(event_task_2.FK_tasks_tasks_status);
            if (typeof (event_task_2.FK_tasks_tasks_status) !== "undefined" && event_task_2.FK_tasks_tasks_status != null) {
                if (event_task_2.FK_tasks_tasks_status.code == 'CANCELED') color = "#ed5565";
                if (event_task_2.FK_tasks_tasks_status.code == 'COMPLETED') color = "#1ab394";
                if (event_task_2.FK_tasks_tasks_status.code == 'PENDING' || event_task_2.FK_tasks_tasks_status.code == 'IN_PROGRESS') color = "#f8ac59";
            }
            $scope.gantt_data.push({
                name: event_task_2.title,
                parent: event_task_2.title,
                tasks: [{
                    task_id: event_task_2.id,
                    name: event_task_2.title,
                    color: color,
                    progress: (typeof (event_task_2.FK_tasks_tasks_status) !== "undefined" && event_task_2.FK_tasks_tasks_status != null && event_task_2.FK_tasks_tasks_status.code == 'IN_PROGRESS') ? event_task_2.work_progress : "",
                    content: "<font color='white'>" + event_task_2.title + "</font>",
                    contentTooltip: $sce.trustAsHtml(contentTooltip),
                    from: moment(event_task_2.date_from),
                    to: moment(event_task_2.date_to)
                }]
            });
        }

        //API gantt
        $scope.registerApi = function (api) {
            logService.debug("registerApi");
            $scope.api = api;
            api.directives.on.new($scope, function (dName, dScope, dElement, dAttrs, dController) {
                if (dName === 'ganttTask') {
                    dElement.bind('click', function (event) {                                                    
                        logService.debug("entra aqui en task-list.js linea324");
                        $scope.addTask(dScope.task.model.task_id);

                    });
                }
            });
        };


        $scope.addTask = function (id, edit = false) {
            logService.debug(id);
            logService.debug(edit);
           // if ($scope.allowWrite && ((edit && id != null) || !edit)) {
                let $modalInstance = $uibModal.open({
                    animation: true,
                    template: TaskModalView,
                    controller: "TaskModalCtrl",
                    size: 'lg',
                    resolve: {
                        task_id: function () {
                            return id;
                        },
                        entity_type: function () {
                            return entity_type;
                        },
                        entity_type_id: function () {
                            return entity_type_id;
                        },
                        type: function () {
                            return "task";
                        },
                        show_groups: function () {
                            return $scope.show_groups;
                        }
                    }

                });

                //Retorno de los datos desde el modal.
                $modalInstance.result.then(function (resultModal) {
                    //if ($state.current.name == 'events.edit.tasks') {
                    if (angular.isDefined($scope.gridOptionsTasks.gridApi)) {
                        $scope.gridOptionsTasks.gridApi.core.raise.itemChanged($scope);
                        if ($scope.show_groups) $scope.gridOptionsTasks.gridApi.treeBase.expandAllRows();
                    }
                    //}                  

                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();

                }, function () {
                    console.info('Modal dismissed at: ' + new Date());
                    //  $scope.identity = {};
                });
           // }
        };

        /*
            * Si lleva el parámetro abro el elemento
            */
        if (angular.isDefined($stateParams.taskId) && $stateParams.taskId != null && $stateParams.taskId != "")
            $scope.addTask($stateParams.taskId)


        $scope.addTaskGroup = function (id) {
            let $modalInstance = $uibModal.open({
                animation: true,
                template: TaskModalView,
                controller: "TaskModalCtrl",
                size: 'lg',
                resolve: {
                    task_id: function () {
                        return id;
                    },
                    entity_type: function () {
                        return entity_type;
                    },
                    entity_type_id: function () {
                        return entity_type_id;
                    },
                    type: function () {
                        return "group";
                    },
                    show_groups: function () {
                        return $scope.show_groups;
                    }
                }

            });

            //Retorno de los datos desde el modal.
            $modalInstance.result.then(function (resultModal) {
                if (angular.isDefined($scope.gridOptionsTasks.gridApi)) {
                    $scope.gridOptionsTasks.gridApi.core.raise.itemChanged($scope);
                    if ($scope.show_groups) $scope.gridOptionsTasks.gridApi.treeBase.expandAllRows();
                }
                if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();

            }, function () {
                console.info('Modal dismissed at: ' + new Date());
                //  $scope.identity = {};
            });
        };


        //Delete desde el listado
        $scope.deleteDialog = function (id, title) {
                
            modalService.confirm({
                title: $filter('translate')('events.tasks.button_delete'),
                message: $filter('translate')('events.tasks.delete_message') + " " + title + "?",
                onAccept: function () {
                    Restangular.one('Tasks', id).remove().then(function () {
                        toastr.success($filter('translate')('events.tasks.deleted_success'));
                        if (angular.isDefined($scope.gridOptionsTasks.gridApi)) {
                            $scope.gridOptionsTasks.gridApi.core.raise.itemChanged($scope);
                            if ($scope.show_groups) $scope.gridOptionsTasks.gridApi.treeBase.expandAllRows();
                            //  $scope.gridOptionsTasks.loadData();

                        }
                    }, function (response) {
                        logService.error("Error with status code", response.status);
                        alert("Error al borrar")
                    });
                }
            });
        };            
          
        $scope.export = function () {
            var options = {
                filters: {
                }
            };    
            datasetsService.exportByType("tasks", options);
        };

    }])

    .controller("TaskModalCtrl", ['LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', 'task_id', 'entity_type', 'entity_type_id', 'type', 'show_groups', 'uiSliderConfig', '$uibModal', 'logService',
        function (LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, task_id, entity_type, entity_type_id, type, show_groups, uiSliderConfig, $uibModal, logService) {
    
    //Comprobamos si tiene permiso escritura
    $scope.allowWrite = LoginService.permissionExist("TASKS_WRITE");
    $scope.send_notifications = false;
    $scope.task = {};
    $scope.selectedUsersIdS = [];
        $scope.type = type; 
        $scope.show_groups = show_groups;
    $scope.selectTaskGroups = [];
    $scope.borderRight = {"border-right":"none"};
    $scope.widthGanttContainer = "10000px"; //var widthShow = angular.element("#gantt-container-shown .gantt-side").width() + angular.element('#gantt-container-shown .gantt-scrollable-header').width();

    $scope.GanttContainerStyle = {
        "width": "4000px"
        }

        logService.debug(task_id);
        
        if (angular.isUndefined(task_id) || task_id == null) {
        $scope.task.entity_type = entity_type;
        $scope.task.entity_type_id = entity_type_id;
        $scope.task.all_day = true;        
        $scope.task.work_progress = 0;
        $scope.task.task_id = 0;
        
        Restangular.all('Users').getList().then(function (results) {
            $scope.selectUsers = results;             
        });

        if ($scope.type == "task") {
            let params = {
                entity_type: entity_type,
                entity_type_id: entity_type_id,
                is_group: true
            }
            Restangular.all('Tasks').getList(params).then(function (results) {
                $scope.selectTaskGroups = results;
                var withoutGroup = {
                    id: 0,
                    title: $filter('translate')('events.tasks.without_group'),
                    is_group: true
                };
                $scope.selectTaskGroups.unshift(withoutGroup);
                if (!$scope.$$phase) $scope.$apply();
            });
        }
    } else {
        
        Restangular.one('Tasks', task_id).get().then(function (results) {
            $scope.task = results;
            
            if ($scope.task.task_id == null) $scope.task.task_id = 0;
            
            if ($scope.type == "task") {
                let params = {
                    entity_type: $scope.task.entity_type,
                    entity_type_id: $scope.task.entity_type_id,
                    is_group: true
                }
                Restangular.all('Tasks').getList(params).then(function (results) {
                    $scope.selectTaskGroups = results;
                    var withoutGroup = {
                        id: 0,
                        title: $filter('translate')('events.tasks.without_group'),
                        is_group: true
                    };
                    $scope.selectTaskGroups.unshift(withoutGroup);
                    if (!$scope.$$phase) $scope.$apply();
                });
            }
            
            if (!$scope.task.is_group) {                
                $scope.type = "task";
                $scope.newActivity = "";
                $scope.borderRight = { "border-right": "1px solid #e7eaec" };
                Restangular.all('TasksActivities').getList({ task_id: $scope.task.id }).then(function (activities) {
                    $scope.activities = activities;
                })
            } else {
                $scope.type = "group";
            }
            if ($scope.task.date_from != null) {
                $scope.task.date_from = new Date($scope.task.date_from);
            }
            if ($scope.task.date_to != null) {
                $scope.task.date_to = new Date($scope.task.date_to);
            }
                
            angular.forEach($scope.task.FK_tasks_users_tasks, function (taskUser) {
                $scope.selectedUsersIdS.push(taskUser.FK_tasks_users_users.id);
            });
            Restangular.all('Users').getList().then(function (results) {
                $scope.selectUsers = results;
                $scope.task.selected_users = [];
                angular.forEach($scope.selectUsers, function (user) {
                    if ($scope.selectedUsersIdS.indexOf(user.id) != -1) {
                        $scope.task.selected_users.push(user);
                    }
                });                
            });
        });
    }

    $scope.slider = {
        options: {
            min: 0,
            max: 100,
            range: 'min',                        
        }
    }

    $scope.setPrice = function (price) {
        $scope.price = price;
    }

    //var entityType = (angular.isUndefined(task_id) ? entity_type : $scope.task.entity_type); // si estás editando, pones el de la edición, sino el que llega.
    Restangular.all('TasksTypes').getList({ entity_type: entity_type }).then(function (results) {
        $scope.selectTaskTypes = results;
        if (results.length == 1 && (angular.isUndefined(task_id) || task_id == null)) {
            //lo preseleccionamos por defeco.
            $scope.task.FK_tasks_tasks_types = results[0];
        }
    });
    
    Restangular.all('TasksStatus').getList({ entity_type: entity_type }).then(function (results) {
        $scope.selectTaskStatus = results;
        if (angular.isUndefined($scope.task.id)) {
            $scope.task.FK_tasks_tasks_status = $scope.selectTaskStatus[0];
        }
    });

    $scope.saveTask = function () {
        if ($scope.task.task_id == 0) $scope.task.task_id = null;
        $scope.task.FK_tasks_users_tasks = [];
        if ($scope.type == "group") {
            $scope.task.is_group = 1;
        } else {
            $scope.task.task_type_id = (typeof ($scope.task.FK_tasks_tasks_types) !== "undefined" && $scope.task.FK_tasks_tasks_types != null ? $scope.task.FK_tasks_tasks_types.id : null);
            $scope.task.task_status_id = (typeof ($scope.task.FK_tasks_tasks_status) !== "undefined" && $scope.task.FK_tasks_tasks_status != null ? $scope.task.FK_tasks_tasks_status.id : null);
            angular.forEach($scope.task.selected_users, function (user) {
                $scope.task.FK_tasks_users_tasks.push({
                    task_id: $scope.task.id,
                    user_id: user.id
                })
            })
        }
        if ($scope.task.date_from > $scope.task.date_to) {
            let hour = $scope.task.date_to.getHours();
            let minutes = $scope.task.date_to.getMinutes();

            $scope.task.date_to = angular.copy($scope.task.date_from);
            $scope.task.date_to.setHours(hour);
            $scope.task.date_to.setMinutes(minutes);
        } 


        if (angular.isDefined($scope.task.id)) {
            $scope.task.put().then(function (result) {
                if (angular.isDefined(result.id)) {                    
                    $uibModalInstance.close();
                    toastr.success($filter('translate')('events.tasks.edit_success'));
                } 
            });
        } else {
            Restangular.all('Tasks').post($scope.task).then(function (result) {
                if (angular.isDefined(result.id)) {
                    $uibModalInstance.close();
                    toastr.success($filter('translate')('events.tasks.add_success'));

                } 
            });
        }
    }

    $scope.onCancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    //Delete desde el popup
    $scope.checkDeleteTask = function () {
        modalService.confirm({
            title: $filter('translate')('events.tasks.button_delete'),
            message: $filter('translate')('events.tasks.delete_message') + " " + $scope.task.title + "?",
            onAccept: function () {
                Restangular.one('Tasks', $scope.task.id).remove({send_notifications : $scope.task.send_notifications}).then(function () {
                //$scope.task.remove().then(function () {                    
                    $uibModalInstance.close();
                    if (typeof $scope.refetchEvents == 'function') $scope.refetchEvents();
                });
            }
        });
    };

    // Gestión de actividades sobre una tarea
    $scope.addActivity = function (newActivity) {
        
        $scope.activity = {
            title: newActivity,
            task_id: $scope.task.id
        }
        Restangular.all('TasksActivities').post($scope.activity).then(function (result) {
            $scope.activities = result;
            delete $scope.newActivity;            
        });        
    }

    $scope.deleteActivity = function (id) {
        Restangular.one('TasksActivities', id).remove().then(function (result) {
            $scope.activities = result;
        });
    }

    $scope.showHistory = function (id) {
        logService.debug("TODO: falta ver que histórico se pretende mostra aqui....")

    }
    
}])

;

;